import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge Tailwind class names with proper conflict resolution.
 *
 * `clsx` flattens conditional/falsy values into a class string; `tailwind-merge`
 * then dedupes conflicting Tailwind utilities (last wins), so a consumer's
 * `className` prop actually overrides the base classes. Used by shadcn/ui
 * primitives and any component that exposes a `className` override.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
